import axios from 'axios'
import {handleClose} from "./WebSocket/LogOutEvent";
import globalRouter from "./globalRouter";

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => {
        // Modify the response data here (e.g., parse, transform)

        return response;
    },
    async (error) => {
        // Handle response errors here
        if (error.response.status === 401) {
            await handleSignOut();
            globalRouter.navigate("/");
        }
    }
);

const handleSignOut = async () => {
    const storedAccessToken = localStorage.getItem('accessToken');
    if (storedAccessToken) {
        await fetch(`${process.env.REACT_APP_BASE_URL}/auth/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${storedAccessToken}`,
            },
            body: JSON.stringify({refresh_token: storedAccessToken}), // Pass the access token in the request body
        })
            .then(response => {
                localStorage.removeItem("accessToken");
                localStorage.setItem("loggedIn", true);
                localStorage.setItem('QA', "logOut");
                globalRouter.navigate("/");
                handleClose()
            })
            .catch(error => {
                // handle the error here if needed
            });
    }
};

export default api;
